import { Component, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationService, Notification, NotificationComponent, DialogService } from '../../shared/index'; //app/shared/index barrel;
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../shared/events.service';
import { ConfigService } from '../../config/shared/config.service';
import { EventRead } from '../shared/event-read.model';
import { EventCopy } from '../shared/event-copy.model';
import { Router } from '@angular/router';
import { RegistrationWizardComponent } from '../registration/wizard/registration-wizard.component';

/**
 * You are probably in the wrong component.
 * You are probably in the wrong component.
 * You are probably in the wrong component.
 * You are looking for event/settings/event-settings.component
 * You are looking for event/settings/event-settings.component
 * You are looking for event/settings/event-settings.component
 * You are looking for event/settings/event-settings.component
 * You are looking for event/settings/event-settings.component
 */
@Component({
  selector: 'wl-events-detail',
  templateUrl: 'event-detail.component.html',
  styleUrls: ['event-detail.component.css'],
  providers: [EventsService, ConfigService],
  //pipes: [TranslatePipe]
    standalone: false
})
export class EventDetailComponent {
  public id: number;
  public event: EventRead;
  public eventUrl: string;
  public copyMessage: string;

  constructor(
    public _route: ActivatedRoute,
    public _eventsService: EventsService,
    public _dialogService: DialogService,
    public _configService: ConfigService,
    public _translateService: TranslateService,
    public _router: Router
  ) {
    this.event = new EventRead();
  }

  ngOnInit() {
    //this._route.params
    //    .map(params => params['id'])
    //    .subscribe((id) => {
    //        this.loadEvent(id);
    //        this.id = id;
    //    });
    this._route.paramMap.subscribe((params) => {
      this.id = parseInt(params.get['id']);
      this.loadEvent(this.id);
    });

    this._translateService.get('events.detail.component.copy').subscribe((value: string) => {
      this.copyMessage = value;
    });
  }

  public dulplicateClick = (): void => {
    this._dialogService.confirmYesNo(
      this.copyMessage,
      () => {
        this.copyEvent(this.id);
      },
      null
    );
  };

  public deleteClick = (): void => {
    this._dialogService.confirmYesNo(
      'Delete placeholder. See WC-24',
      function () {},
      function () {}
    );
  };

  public copyEvent = (eventId: number): void => {
    this._dialogService.showWaitIndicator();
    this._eventsService.copyEvent(this.id, new EventCopy(this.id)).then(
      (newEventId) => {
        this._dialogService.closeWaitIndicator();
        this._router.navigate(['/events/detail/' + newEventId.toString()]);
      },
      (error: any) => {
        this._dialogService.error(error);
      }
    );
  };

  public loadEvent = (eventId: number): void => {
    Promise.all([
      this._eventsService.getEventRead(eventId).then(
        (data: any) => {
          this.event = data;
        },
        (error: any) => {}
      ),
      this._configService.getWebRoot().then(
        (data: any) => {
          this.eventUrl = data;
        },
        (error: any) => {}
      ),
    ]).then((values) => {
      this.eventUrl += '/events/-' + eventId + '/details';
    });
  };

  public newRegistration = (): void => {};

  public registrationSaved = (registrationId: number) => {
    this._dialogService.alert('Message', 'Registration ' + registrationId.toString() + ' saved.');
  };
}
